import React, { useEffect, useState } from "react";
import "./viewFranchise.css";
import SearchBar from "../Main/searchBar";
import { Link, useParams } from "react-router-dom";
import { ReactComponent as BackIcon } from "../../Assets/Categories/BackIcon.svg";
import { useDispatch } from "react-redux";
import { DateToLocale, ToFirstCapital } from "../../Utils/helpers";
import toast from "react-hot-toast";
import axios from "axios";
import { viewFranchise } from "../../Redux/Actions/franchiseAction";

const BASE_URL = process.env.REACT_APP_API_BASE_URL;

const ViewFranchise = () => {
  const { id } = useParams();
  const dispatch = useDispatch();

  const [franchiseData, setFranchiseData] = useState(null);
  const [status, setStatus] = useState("");
  const [showConfirm, setShowConfirm] = useState(false);
  const [selectedStatus, setSelectedStatus] = useState("");
  const [isUpdating, setIsUpdating] = useState(false);
  const ACCOUNT_STATUS_OPTIONS = [
    "requested",
    "pending",
    "unblock",
    "block",
    "inreview",
    "approved",
    "declined",
    "rejected",
  ];

  useEffect(() => {
    if (id) {
      dispatch(viewFranchise(id)).then((res) => {
        if (res?.data) {
          setFranchiseData(res.data);
          if (res.data.account_status) setStatus(res.data.account_status);
        }
      });
    }
  }, [id, dispatch]);

  const handleStatusChange = (e) => {
    setSelectedStatus(e.target.value);
    setShowConfirm(true);
  };

  const confirmStatusChange = async () => {
    if (!id) {
      toast.error("Invalid franchise ID");
      setShowConfirm(false);
      return;
    }
    setIsUpdating(true);
    setShowConfirm(false);
    try {
      await axios.post(`${BASE_URL}/franchise/account-status-update`, {
        franchise_id: id,
        status: selectedStatus,
      });
      toast.success("Status updated successfully!");
      setStatus(selectedStatus);
      const res = await dispatch(viewFranchise(id));
      if (res?.data) {
        setFranchiseData(res.data);
        if (res.data.account_status) setStatus(res.data.account_status);
      }
    } catch (error) {
      toast.error("Error updating status");
    } finally {
      setIsUpdating(false);
    }
  };

  if (!franchiseData) {
    return <div>Loading...</div>;
  }

  return (
    <div
      style={{
        display: "grid",
        gridTemplateColumns: "repeat(7, 1fr)",
        gridAutoRows: "minmax(60px, auto)",
      }}
      className="padding-20 gap-10 grid-container"
    >
      <div style={{ gridColumn: "3/8" }}>
        <SearchBar style={{ width: "max-content" }} />
      </div>

      <div
        className="back-icon margin-0 gap-10 align-center flex-container"
        style={{ gridColumn: "span 7" }}
      >
        <Link to="/franchise">
          <BackIcon style={{ cursor: "pointer" }} />
        </Link>
        <div>
          <h3>{franchiseData?.brand_name || "Franchise Details"}</h3>
          <h4 style={{ position: "relative", top: "-10px" }}>
            Franchise / List / View
          </h4>
        </div>
      </div>

      <div
        className="overall-container"
        style={{ opacity: isUpdating ? 0.6 : 1 }}
      >
        {isUpdating && (
          <div className="loading-overlay">
            <div className="loading-spinner"></div>
          </div>
        )}

        <div className="franchise-content-wrapper">
          <div className="franchise-main-layout">
            {/* Left Side - Brand Logo */}
            <div className="brand-logo-section">
              {franchiseData?.brand_logo ? (
                <>
                  <img
                    src={franchiseData.brand_logo}
                    alt={`${franchiseData.brand_name} Logo`}
                    className="brand-logo-image"
                  />
                  <div className="brand-name-display">
                    {franchiseData.brand_name}
                  </div>
                </>
              ) : (
                <div
                  style={{
                    width: 200,
                    height: 200,
                    border: "2px dashed rgba(255, 255, 255, 0.2)",
                    borderRadius: 16,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    color: "#8B93A7",
                    fontSize: 14,
                  }}
                >
                  No Logo Available
                </div>
              )}
            </div>

            {/* Right Side - Franchise Details */}
            <div>
              <div className="franchise-grid">
                {/* Basic Information */}
                <Field
                  label="Brand Name"
                  value={franchiseData.brand_name}
                  className="franchise-field"
                />
                <Field
                  label="Organization Name"
                  value={franchiseData.organization_name}
                  className="franchise-field"
                />
                <Field
                  label="Franchise ID"
                  value={franchiseData.franchise_id}
                  className="franchise-field"
                />
                <Field
                  label="RERA ID"
                  value={franchiseData.rera_id}
                  className="franchise-field"
                />

                {/* Contact Information */}
                <Field
                  label="Primary Contact"
                  value={`+${franchiseData.primary_country_code}  ${franchiseData.primary_contact_number}`}
                  className="franchise-field contact-field"
                />
                <Field
                  label="Primary Email"
                  value={franchiseData.primary_email}
                  className="franchise-field contact-field"
                />

                {/* Address Information */}
                <Field
                  label="Street Address"
                  value={franchiseData.street_address}
                  className="franchise-field address-field"
                />
                <Field
                  label="City"
                  value={franchiseData.city?.city_name}
                  className="franchise-field address-field"
                />
                <Field
                  label="State"
                  value={franchiseData.state?.state_name}
                  className="franchise-field address-field"
                />
                <Field
                  label="Country"
                  value={franchiseData.country?.country_name}
                  className="franchise-field address-field"
                />
                <Field
                  label="Zipcode"
                  value={franchiseData.zipcode}
                  className="franchise-field address-field"
                />

                {/* Status Information */}
                <Field
                  label="Account Status"
                  value={ToFirstCapital(status)}
                  className="franchise-field status-field"
                />
                <Field
                  label="Email Verified"
                  value={franchiseData.is_primary_email_verified ? "Yes" : "No"}
                  className="franchise-field verification-field"
                />
                <Field
                  label="Contact Verified"
                  value={
                    franchiseData.is_primary_contact_number_verified
                      ? "Yes"
                      : "No"
                  }
                  className="franchise-field verification-field"
                />
                <Field
                  label="Profile Completed"
                  value={franchiseData.is_profile_completed ? "Yes" : "No"}
                  className="franchise-field verification-field"
                />

                {/* Date Information */}
                <Field
                  label="Registration Date"
                  value={
                    franchiseData.organization_registration_date || "No Data"
                  }
                  className="franchise-field date-field"
                />
                <Field
                  label="Created At"
                  value={
                    franchiseData.created_at
                      ? DateToLocale(franchiseData.created_at)
                      : "No Data"
                  }
                  className="franchise-field date-field"
                />
              </div>

              {/* Status Update Section */}
              <div className="status-update-section">
                <div className="field-label">Update Account Status</div>
                <select
                  className="status-select"
                  value={status}
                  onChange={handleStatusChange}
                  disabled={isUpdating}
                >
                  <option value="">Select Status</option>
                  {ACCOUNT_STATUS_OPTIONS.map((stat) => (
                    <option key={stat} value={stat}>
                      {ToFirstCapital(stat)}
                    </option>
                  ))}
                </select>
              </div>
            </div>
          </div>
        </div>

        {/* Confirmation Modal */}
        {showConfirm && (
          <div className="modal-backdrop">
            <div className="modal-content">
              <p style={{ fontSize: 16, color: "black"}}>
                Are you sure you want to change status to{" "}
                <strong style={{ color: "black" }}>
                  "
                  {selectedStatus.charAt(0).toUpperCase() +
                    selectedStatus.slice(1)}
                  "
                </strong>
                ?
              </p>
              <div className="modal-buttons">
                <button
                  onClick={confirmStatusChange}
                  disabled={isUpdating}
                  className="modal-button confirm"
                >
                  {isUpdating ? "Updating..." : "Confirm"}
                </button>
                <button
                  onClick={() => setShowConfirm(false)}
                  disabled={isUpdating}
                  className="modal-button cancel"
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

// Enhanced Field component with better styling
const Field = ({ label, value, className = "franchise-field" }) => (
  <div className={className}>
    <div className="field-label">{label}</div>
    <div className="field-value">{value ?? "No Data"}</div>
  </div>
);

export default ViewFranchise;
